import { render, staticRenderFns } from "./reportePtiAceptados.vue?vue&type=template&id=5f45e008&scoped=true"
import script from "./reportePtiAceptados.vue?vue&type=script&lang=js"
export * from "./reportePtiAceptados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f45e008",
  null
  
)

export default component.exports